import { Modal, ModalWidth } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { ReactElement } from 'react';
import { useGlobalModalContext } from '../../../GlobalModal';
import styles from './LockedArticleModal.module.scss';
import LockedArticleContent from '../LockedArticleContent/LockedArticleContent';
import { ArticlePermissions } from '../../../../models';
import { getHeaderTitle } from '../lockedArticleUtils';

const cx = classNames.bind(styles);

export interface LockedArticleModalProps {
  articlePermissions: ArticlePermissions;
}

const LockedArticleModal = ({ articlePermissions }: LockedArticleModalProps): ReactElement => {
  const { closeModal } = useGlobalModalContext();

  return (
    <Modal
      dataTestId="locked-article-modal"
      headerTitle={getHeaderTitle(articlePermissions.accessStatus)}
      onClose={closeModal}
      width={ModalWidth.Medium}
      className={cx('body')}
      open
    >
      <LockedArticleContent inlineContent={false} articlePermissions={articlePermissions} />
    </Modal>
  );
};

export default LockedArticleModal;
